import ApplicationComponent from "legacy/ApplicationComponent"
import FormGroup from "legacy/FormGroup"
import SegmentedControl from "legacy/SegmentedControl"
import StripeElement from "legacy/credit-cards/StripeElement"
import { centsToDollars, dollarsToCents } from "legacy/helpers.es6"
// Removed lodash import
import PropTypes from "prop-types"
import React from "react"

class PaymentSelectCart extends ApplicationComponent {
  constructor(args) {
    super(args)
    this.state = {
      cashTendered: "",
      cardSuccess: false,
    }
    this.setPaymentType = this.setPaymentType.bind(this)
    this.tokenizeCard = this.tokenizeCard.bind(this)
    this.handleStripeError = this.handleStripeError.bind(this)
    this.handleStripeSuccess = this.handleStripeSuccess.bind(this)
    this.handleInputCashTendered = this.handleInputCashTendered.bind(this)
    this.handleInputCheckNumber = this.handleInputCheckNumber.bind(this)
    this.handleCardSelect = this.handleCardSelect.bind(this)
    this.renderChangeDue = this.renderChangeDue.bind(this)
    this.renderCardsLoading = this.renderCardsLoading.bind(this)
    this.renderCartTotal = this.renderCartTotal.bind(this)
    this.renderInputs = this.renderInputs.bind(this)

    this.stripeElement = null
    this.setStripeElementRef = (element) => {
      this.stripeElement = element
    }
  }

  tokenizeCard() {
    this.stripeElement.createStripePaymentMethod()
  }

  setPaymentType(paymentType) {
    if (paymentType === "cash" || paymentType === "check") {
      // Note: Amplitude is loaded globally
      Amplitude.trackEvent("web_pos:create_add_payment_manual", paymentType)
    }
    const paymentMethod = {
      ...this.props.cart.paymentMethod,
      type: paymentType,
    }
    this.props.handleUpdatePaymentMethod(paymentMethod)
  }

  handleInputCashTendered(input) {
    this.setState({ cashTendered: input })
  }

  handleInputCheckNumber(checkNumber) {
    const paymentMethod = {
      ...this.props.cart.paymentMethod,
      checkNumber,
    }
    this.props.handleUpdatePaymentMethod(paymentMethod)
  }

  handleCardSelect(cardId) {
    // Note: Amplitude is loaded globally
    Amplitude.trackEvent("web_pos:create_add_payment_cc")
    const paymentMethod = { ...this.props.cart.paymentMethod, cardId }
    this.props.handleUpdatePaymentMethod(paymentMethod)
  }

  handleStripeSuccess(response) {
    // Note: Amplitude is loaded globally
    Amplitude.trackEvent("web_pos:create_add_new_payment_cc")
    const paymentMethod = {
      ...this.props.cart.paymentMethod,
      cardId: "add_new_card",
      stripeToken: response.id,
    }
    this.props.handleUpdatePaymentMethod(paymentMethod)
  }

  handleStripeError() {
    this.props.handleUpdatePaymentMethod({ error: "Error Adding Card" })
  }

  renderChangeDue() {
    if (this.state.cashTendered > 0 && this.props.cartTotal > 0) {
      return centsToDollars(
        parseFloat(dollarsToCents(this.state.cashTendered)) -
          this.props.cartTotal
      )
    }
  }

  renderCardsLoading() {
    return (
      <div
        className={"form-group mt-5 flex items-center justify-between gap-x-4"}
      >
        <div className={"flex w-1/3 justify-start"}>
          <label className={"mb-0 mt-1"}>Card</label>
        </div>
        <div className={"flex w-1/3 justify-center"}>
          <i className="fa-solid fa-spinner-third fa-spin" />
        </div>
        <div className={"w-1/3"} />
      </div>
    )
  }

  renderCartTotal() {
    // Note: centsToDollars is loaded globally
    if (this.props.loadingPrices) {
      return (
        <span className="text-right text-gray-600">
          <i className="fa-solid fa-spinner-third fa-spin text-right" />
        </span>
      )
    } else if (this.props.cartTotal) {
      return (
        <p className="text-right">{centsToDollars(this.props.cartTotal)}</p>
      )
    } else {
      return <p className="text-right">$0.00</p>
    }
  }

  renderInputs() {
    switch (this.props.cart.paymentMethod.type) {
      case "credit":
        return (
          <div>
            {!this.props.isGuest() && !this.props.loadingCustomerCards && (
              <FormGroup
                inputType="select"
                label="Card"
                labelClassName="mt-1 w-24"
                value={this.props.cart.paymentMethod.cardId}
                name="credit"
                onChange={(event) => this.handleCardSelect(event.target.value)}
                className="mt-5 flex gap-x-4"
              >
                {
                  <option defaultValue value="select_card">
                    Select an option:
                  </option>
                }
                {this.props.customerCards.map((card) => (
                  <option
                    key={card.stripePaymentMethodId}
                    value={card.stripePaymentMethodId}
                  >
                    {card.title}
                  </option>
                ))}
                <option value="add_new_card">Add New Card</option>
              </FormGroup>
            )}
            {this.props.loadingCustomerCards && this.renderCardsLoading()}
            {this.props.cart.paymentMethod.cardId === "add_new_card" && (
              <StripeElement
                ref={this.setStripeElementRef}
                successCallback={this.handleStripeSuccess}
                errorCallback={this.handleStripeError}
              />
            )}
          </div>
        )
      case "cash":
        return (
          <div>
            <div className="mt-5 grid grid-cols-2 rounded bg-gray-100 p-4">
              <p>Total Due</p>
              {this.renderCartTotal()}
              <hr className="col-span-full col-start-1 m-0 mb-1" />
              <FormGroup
                inputType="currency"
                label="Cash Tendered"
                labelClassName="mt-2.5 w-72"
                value={this.state.cashTendered}
                name={this.props.cart.paymentMethod.type}
                onChange={(event) =>
                  this.handleInputCashTendered(event.target.value)
                }
                className="col-span-full mb-1.5 flex gap-x-4"
              />
              <hr className="col-span-full col-start-1 m-0 mb-1" />
              <p className="mt-2.5">Change Due</p>
              <p className="mt-2.5 text-right font-bold">
                {this.renderChangeDue()}
              </p>
            </div>
          </div>
        )
      case "check":
        return (
          <FormGroup
            inputType="input"
            label="Check #"
            labelClassName="mt-1 w-24"
            value={this.props.cart.paymentMethod.checkNumber}
            name="check"
            onChange={(event) =>
              this.handleInputCheckNumber(event.target.value)
            }
            className="mt-5 flex gap-x-4"
          />
        )
    }
  }

  render() {
    return (
      <div className="mt-2">
        <SegmentedControl
          style="blue"
          segments={[
            { id: "credit", title: "Card" },
            { id: "cash", title: "Cash" },
            { id: "check", title: "Check" },
          ]}
          handleSelection={this.setPaymentType}
          selectedSegment={this.props.cart.paymentMethod.type}
        />
        {this.renderInputs()}
      </div>
    )
  }
}

PaymentSelectCart.propTypes = {
  cart: PropTypes.shape({
    paymentMethod: PropTypes.shape({
      type: PropTypes.string.isRequired,
      cardId: PropTypes.string,
      checkNumber: PropTypes.string,
    }).isRequired,
  }).isRequired,
  cartTotal: PropTypes.number,
  customerCards: PropTypes.array,
  isGuest: PropTypes.func.isRequired,
  loadingCustomerCards: PropTypes.bool,
  loadingPrices: PropTypes.bool,
  handleUpdatePaymentMethod: PropTypes.func.isRequired,
}

PaymentSelectCart.defaultProps = {
  customerCards: [],
  loadingCustomerCards: false,
  loadingPrices: false,
  cartTotal: 0,
}

export default PaymentSelectCart
